import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="footer position-absolute mt-3">
    <div className="row g-0 justify-content-between align-items-center h-100">
        <div className="col-12 col-sm-auto text-center">
            <p className="mb-0 mt-2 mt-sm-0 text-body">Designed & Developed by <Link className="mx-1" to="tel:+919982158760">Mukan Singh</Link><span
                    className="d-none d-sm-inline-block"></span><span className="d-none d-sm-inline-block mx-1">|</span><br
                    className="d-sm-none" />&copy; 2025 - 2027 <Link className="mx-1" to="/">FMS</Link></p>
        </div>
        <div className="col-12 col-sm-auto text-center">
            <p className="mb-0 text-body-tertiary text-opacity-85 app-version">v1.1.0</p>
        </div>
    </div>
</footer>
);

export default Footer;
